module.exports = __webpack_public_path__ + "ac55700bb979e66b01c8e661e711937a.jpg";